import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getRealEstateProjects, getTariffIncreasePlanAvailableColumns } from './api';

export const path = '/tariff-increase-plan/list';

const PageTariffIncreasePlanList: React.FC = (props) => {
  const TariffIncreasePlanList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getTariffIncreasePlanAvailableColumns,
      projects: getRealEstateProjects,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <TariffIncreasePlanList {...props} />;
};

export default PageTariffIncreasePlanList;
